import { ButtonDatumType } from "../../types";
import convertToTitleCase from "../text/convertToTitleCase";

const buttonsData: Record<string, ButtonDatumType> = {
  app: { color: "white", backgroundColor: "green" },
  repo: { color: "white", backgroundColor: "blue" },
  android: { color: "white", backgroundColor: "#a4c639" },
  ios: { label: "iOS", color: "white", backgroundColor: "black" },
  npm: { label: "npm", color: "white", backgroundColor: "black" },
  demo: { color: "white", backgroundColor: "green" },
  web: { color: "white", backgroundColor: "#0077b5" },
  server: { label: "Server", color: "white", backgroundColor: "#6c757d" },
  close: { color: "white", backgroundColor: "red" },
  default: { color: "white", backgroundColor: "#555" },
};

const normalizeSlug = (slug: string): string =>
  slug.toLowerCase().replace(/\s+/g, "");

export const getButtonStyle = (textSlug: string): ButtonDatumType => {
  const key = normalizeSlug(textSlug);
  return buttonsData[key] || buttonsData.default;
};

export const getButtonLabel = (
  textSlug: string,
  style: ButtonDatumType,
  customLabel?: string,
): string => customLabel || style.label || convertToTitleCase(textSlug);

export const ensureAbsoluteUrl = (link: string): string => {
  if (!link || link === "close") return link;
  if (/^https?:\/\//i.test(link)) return link;
  return `https://${link}`;
};
